import React from 'react'
import T from 'prop-types'
import IT from 'react-immutable-proptypes'
import cx from 'classnames'
import {
  DragSource
} from 'react-dnd'
import {
  TextOverflow
} from 'react-base'

export const TOKEN_DND_ITEM_TYPE = 'mapper_field_token_draggable'

class MapperFieldToken extends React.PureComponent {
  static displayName = 'MapperFieldToken'

  static propTypes = {
    schemaDef: IT.map.isRequired,
    schemaKey: T.string.isRequired,
    onMappingChange: T.func.isRequired,
    connectDragSource: T.func.isRequired,
		isDragging: T.bool.isRequired
  }

  render() {
    const {
      schemaDef,
      isDragging,
      connectDragSource
    } = this.props

    return connectDragSource(
      <div
        className={cx(
          `mapper_field`,
          {
            'is_required': schemaDef.get('required') === true,
            'is_dragging': isDragging
          }
        )}
        style={{ opacity: isDragging ? 0 : 1 }}
      >
        <span className="icon icon-drag-handle" />
        <div>
          <TextOverflow className="field_display">{schemaDef.get('display')}</TextOverflow>
          <div className="field_type">{schemaDef.get('type')}</div>
          {schemaDef.has('desc') &&
            <TextOverflow className="field_desc">{schemaDef.get('desc')}</TextOverflow>
          }
        </div>
      </div>
    )
  }
}


export default DragSource(
  TOKEN_DND_ITEM_TYPE,
  {
    beginDrag(props) {
      return {
        schemaKey: props.schemaKey
      }
    },
    endDrag(props, monitor) {
      const {
        schemaKey,
        onMappingChange
      } = props
      const dropResult = monitor.getDropResult()

      if (dropResult && onMappingChange) {
        const {columnKey} = dropResult
        onMappingChange(schemaKey, columnKey)
      }
      // if (!didDrop) {
      //   props.moveItem(droppedId, originalIndex, originalIsActive)
      // }
    }
  },
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  })
)(MapperFieldToken)